import { push } from "connected-react-router";
import React, { useState, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router';
import { 
    APPLICATION_STATUS_APPROVED_ISSUED, 
    APPLICATION_STATUS_OPENED, 
    APPLICATION_STATUS_PENDING, 
    APPLICATION_STATUS_PENDING_AGENCY, 
    APPLICATION_STATUS_UNDER_REVIEW, 
    APPLICATION_STATUS_UNREAD, 
    LICENCE_STATUS_NEW, 
    LICENCE_STATUS_ACTIVE,
    ROUTE_PATH, 
    APPLICATION_STATUS_WITHDRAWN_APPROVED,
    LICENCE_STATUS_WITHDRAWN_BY_CLIENT,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION,
    APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
} from "../../../app/constants";
import { humanReadableDate, isBranchApplication, licenceSubTypeString } from "../../../app/utils";
import { Button } from "../../../components/RegularComponents";
import { 
    applicationTypeFromLicenceSubType, 
    isMortgageTypeApplication,
    isCollectionTypeApplication,
    isApplicationStatusForProcessedApplication
} from "../../../redux/slice/applicationsUtils";
import { setQueueItem } from "../../../redux/slice/bltReviewSlice";
import ApplicationStatusComponent from "../BLTCommon/ApplicationStatus";

const headers = [
    {
        key: "dateReceived",
        title: "Date received",
        sortBy: "SUBMITTED_DATE",
        sort: (isAscending) => (a, b) =>{
            const aDate = a.submittedDate
            const bDate = b.submittedDate 
            return isAscending ? aDate - bDate : bDate - aDate
        } 
    },
    {
        key: "licenceType",
        title: "Licence type / number",
    },
    {
        key: "name",
        title: "Name",
        sortBy: "CONTACT_NAME",
        sort: (isAscending) => (a, b) =>{
            const aStr = a.name
            const bStr = b.name
            return isAscending ? aStr?.localeCompare(bStr) : bStr?.localeCompare(aStr)
        } 
    },
    {
        key: "agency",
        title: "Agency",
        sortBy: "NAME",
        sort: (isAscending) => (a, b) =>{
            const aStr = a.agency
            const bStr = b.agency
            return isAscending ? aStr?.localeCompare(bStr) : bStr?.localeCompare(aStr)
        } 
    },
    {
        key: "lastModified",
        title: "Last updated",
        sortBy: "DATE_MODIFIED",
        sort: (isAscending) => (a, b) =>{
            const aDate = a.modifiedDateTime
            const bDate = b.modifiedDateTime 
            return isAscending ? aDate - bDate : bDate - aDate
        } 
    },
    {
        key: "status",
        title: "Licence Status",
        sortBy: "LICENCE_STATUS",
        sort: (isAscending) => (a, b) =>{
            const aStr = a.statusParam
            const bStr = b.statusParam
            return isAscending ? aStr?.localeCompare(bStr) : bStr?.localeCompare(aStr)
        } 
    }

]

const formatData = (data) => {
    return data.map(searchResult => {

        let statusParam = searchResult.applicationStatus

        if((searchResult.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED 
            || (searchResult.applicationStatus === APPLICATION_STATUS_WITHDRAWN_APPROVED 
                && searchResult.licenceStatus === LICENCE_STATUS_WITHDRAWN_BY_CLIENT))
            && searchResult.licenceStatus 
            && searchResult.licenceStatus !== LICENCE_STATUS_NEW) {
            statusParam = searchResult.licenceStatus
        }

        const status = (<ApplicationStatusComponent applicationStatus={statusParam} />);

        let considerRenewalName = true;
        if(searchResult.licenceStatus === LICENCE_STATUS_ACTIVE) {
            considerRenewalName = false;
        }
        
        return {
            id: searchResult.id,
            name: searchResult.contactName,
            licenceType: `${licenceSubTypeString(searchResult.licencingSubType, considerRenewalName)}${isBranchApplication(searchResult) ? ' - Branch' : ''}`,
            licencingSubType : searchResult.licencingSubType,
            agency: searchResult.name,
            status,
            lastModified : humanReadableDate(searchResult.modifiedDateTime),
            dateReceived : humanReadableDate(searchResult.submittedDate ? searchResult.submittedDate : searchResult.createdDateTime),
            applicationStatus : searchResult.applicationStatus,
            originalApplicationId : searchResult.originalApplicationId,
            businessApplicationId: searchResult.businessApplicationId,
            licenceNumber: searchResult.licenceNumber,
            licenceStatus: searchResult.licenceStatus,
            submittedDate : searchResult.submittedDate || searchResult.createdDateTime,
            modifiedDateTime : searchResult.modifiedDateTime,
            statusParam
            // lastUpdatedFormatted: humanReadableDate(searchResult.modifiedDateTime ?? searchResult.createdDateTime)
        }
    })
}

export const BLTSearchResults = (props) => {

    const { searchResults } = props;

    const dispatch = useDispatch();

    const [sortingParameters, setSortingParameters] = useState({})

    const location = useLocation();

    const params = useMemo(() => {
        const urlQuery = new URLSearchParams(location.search);
        return {
            licenceTypeText: urlQuery.get("licenceTypeText"),
            licenceTypeOption: urlQuery.get("licenceTypeOption")
        }
    }, [location])

    const rows = useMemo(() => {
        if (!searchResults) { return [] }
        // const header = headers.find(h => h.key === sortingParameters.key)
        // if (!header) { return formatData(searchResults) }

        const newBranches = formatData(searchResults)
        // if(header.sort) {
        //     newBranches?.sort(header.sort(sortingParameters.isAscending));
        // }
        return newBranches

    }, [searchResults])

    const getSortIcon = (header) => {
        if(!header.sort) { return null}
        if (header.key !== sortingParameters?.key) {
            return <i style={{ color: "lightgray" }} className={`fa fa-2x fa-sort`} />
        }
        const activeClass = header.key === sortingParameters?.key ? "active" : ""
        const activeStyle = header.key === sortingParameters?.key ? "#0058a4" : "lightgray"
        const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc"
        return <i style={{ color: activeStyle }} className={`fa fa-2x ${activeClass} ${iconStr}`} />
    }

    const headerClicked = (header) => () => {
        if(!header.sortBy) {
            return;
        }

        let modifiedSortingParams = { ...sortingParameters }
        if (header.key === modifiedSortingParams.key) {
            modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending
        } else {
            modifiedSortingParams = { key: header.key, isAscending: false }
        }

        setSortingParameters(modifiedSortingParams)

        // Set URl
        const sortByType = header.sortBy + (!modifiedSortingParams?.isAscending  ? "_DESC" : "_ASC");
        onFilterChange(sortByType)
        
    }

    const onFilterChange = (sortByType) => {
        const { licenceTypeText, licenceTypeOption } = params;
           
        let url = ROUTE_PATH.BLT_HOME_SEARCH
        if(licenceTypeText) {
            url += `?licenceTypeText=${licenceTypeText}`;
            if(licenceTypeOption) {
                url += `&licenceTypeOption=${licenceTypeOption}`
            }
        }
        else if(licenceTypeOption) {
            url += `?licenceTypeOption=${licenceTypeOption}`
        }

        if(sortByType) {
            url += `&sortType=${sortByType}`
        }

        dispatch(push(url))
                   
    }

    const goToLicenceInformation = useCallback((row) => {
        // // if the itemToReview 
        let url = ROUTE_PATH.BLT_LICENCE_INFORMATION.replace(':qItemId', row.id)

        if(row.originalApplicationId !== null) {
            url = ROUTE_PATH.BLT_LICENCE_INFORMATION.replace(':qItemId', `archiveId=${row.id}`)
        }

        if(isBranchApplication(row)) {
            url = url.replace(':tabKey', 'branches')
        } else {
            url = url.replace(':tabKey', 'information')
        }

        dispatch(push(url))
        
    }, [dispatch])

    const goToApplicationReview = useCallback((row) => {
        dispatch(setQueueItem(null))
        let url = ROUTE_PATH.BLT_REVIEW.replace(':qItemId', row.id)
        dispatch(push(url))
    }, [dispatch])

    const showDetailsButton = ({applicationStatus, licencingSubType}) => {
        
        if(1) { return true }
        
        const appType = applicationTypeFromLicenceSubType(licencingSubType);

        // Details view is not ready for the Mortgage type applications

        // For a collection type applications, show details only if 
        // application is processed.
        if(isCollectionTypeApplication(appType) && 
            isApplicationStatusForProcessedApplication(applicationStatus)) {
            return true
        }

        return false
    }

    const showReviewButton = ({applicationStatus, licencingSubType})  => {

        const appType = applicationTypeFromLicenceSubType(licencingSubType)

        // show "Review" button for the mortgage broker applications even if the 
        // agency review is still pending
        if(isMortgageTypeApplication(appType) && 
            applicationStatus === APPLICATION_STATUS_PENDING_AGENCY) {
            return true
        }

        const reviewStatus = [
            APPLICATION_STATUS_UNREAD, 
            APPLICATION_STATUS_UNDER_REVIEW, 
            APPLICATION_STATUS_PENDING,
            APPLICATION_STATUS_OPENED,
            APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
        ]
        
        if(reviewStatus.find(status => status === applicationStatus)) { 
            return true
        }

        return false
    }

    return (
        <div className="col-lg-12">
            <table className="table bltQueueTable">
                <thead>
                    <tr>
                        {headers.map((h) => (
                            <th key={h.key} style={{ fontSize: "1rem" }} onClick={headerClicked(h)}>
                                <div style={{
                                    display: "inline-flex",
                                    gap: "0.5rem",
                                    alignItems: "center",
                                    cursor: h.sortBy ? "pointer" : "arrow",
                                    paddingRight:"20px"
                                }}>{h.title} {getSortIcon(h)}</div>
                            </th>
                        ))}
                    </tr>
                </thead>
                {rows.length ? (<tbody>
                    {rows.map((row, index) => (
                        <tr key={index}>
                            {headers.map((header, headerIndex) => {
                                const key = header.key;
                                const value = row[key]
                                const formattedValue = header.format ? header.format(value) : value;
                                if(key=== "licenceType") {
                                    return (
                                        <td key={headerIndex}>
                                            <div>{formattedValue}</div>
                                            {row.licenceNumber && <b>{row.licenceNumber}</b>}
                                        </td>
                                    )
                                }
                                return <td key={headerIndex}>{formattedValue}</td>
                            })}
                            <td>
                                {showReviewButton(row) ? 
                                (<Button id={`licence-suspension-detail-${index}`}
                                    className={"licence-queue-review-readonly-button"}
                                    buttonType="regular_primary"
                                    text={
                                        row.licenceStatus === LICENCE_STATUS_ACTIVE &&
                                        !(row.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED || row.applicationStatus === APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) &&
                                        row.licencingSubType !== LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION 
                                        ? "Review document" 
                                        : "Review"
                                    }
                                    onClick={() => goToApplicationReview(row)} />) 
                                : 
                                (showDetailsButton(row) ? (<Button id={`licence-suspension-detail-${index}`}
                                    className={"licence-queue-review-readonly-button"}
                                    buttonType="regular_primary"
                                    text="Details"
                                    onClick={() => goToLicenceInformation(row)} />) : null)}
                            </td>
                        </tr>
                    ))}
                </tbody>
                ) : (<tbody>
                    <tr>
                        <td colSpan="6">
                            <div className="statusText centered">(no items)</div>
                        </td>
                    </tr>
                </tbody>
                )}
            </table>
        </div>
    )
}